import { getUserOktaStatusRequestParamsSchema, getUserOktaStatusResponseSchema } from './types';
export const getUserOktaStatusDef = {
    name: 'getUserOktaStatus',
    requestSchema: getUserOktaStatusRequestParamsSchema,
    responseSchema: getUserOktaStatusResponseSchema,
};
